module.exports = __webpack_public_path__ + "static/pyohio-logo-small-ab92a8f295906ac1c4d7daf943b7f182.png";